import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TMultiSelectFilterGroupInfo, TRenderOptionType } from '../filter/model/ui-filter.types';
import { ModalController, PopoverController } from '@ionic/angular';
import { MOBILE_SCREEN_UTILS } from '../utils';
import { cloneDeep } from 'lodash';
import { TMultiSelectFilter } from '@monorepo/types';

export type TMultiSelectModalModalDismissValue = {
  role: undefined;
  data?: TMultiSelectFilterGroupInfo['items'];
};

@Component({
  selector: 'monorepo-multi-select-popover',
  templateUrl: './multi-select-popover.component.html',
  styleUrls: ['./multi-select-popover.component.scss'],
})
export class MultiSelectPopoverComponent implements OnInit {
  showClose = false;
  filteredPopoverInfo: TMultiSelectFilterGroupInfo['items'] = [];
  _popoverInfo: TMultiSelectFilterGroupInfo['items'] = [];
  searchPlaceholder = 'Search';

  @Input() popoverHeader?: string;
  @Input() popoverBtnText?: string;
  @Input() set popoverInfo(value: TMultiSelectFilterGroupInfo['items']) {
    this._popoverInfo = cloneDeep(value);
    this.filteredPopoverInfo = this._popoverInfo;
  }
  @Input() popoverRenderOptionType: TRenderOptionType = 'MODAL';
  @Input() filterKey!: string;
  @Input() displayName!: string;
  @Input() selectedFilters!: TMultiSelectFilter[];
  @Output() onModelChange = new EventEmitter<TMultiSelectFilterGroupInfo['items']>();
  @Input() virtualScroll?: TMultiSelectFilterGroupInfo['virtualScroll'] = undefined;
  @Input() preTagForDataDisplay: boolean = false;

  constructor(public popoverController: PopoverController, public modalController: ModalController) {
    this.showClose = MOBILE_SCREEN_UTILS.isMobileScreen();
  }

  ngOnInit() {
    if (this.displayName) {
      this.searchPlaceholder = `Search for ${this.displayName}`;
    }
    console.log('this.virtualScroll', this.virtualScroll);
  }

  onSearch($event: Event) {
    const searchValue = ($event.target as HTMLInputElement).value.toLowerCase();
    this.filteredPopoverInfo = this._popoverInfo.filter(
      (item) =>
        item.displayName.toString().toLocaleLowerCase().includes(searchValue) ||
        item.value.toString().toLocaleLowerCase().includes(searchValue),
    );
  }

  onApply(data?: TMultiSelectFilterGroupInfo['items']) {
    switch (this.popoverRenderOptionType) {
      case 'INLINE':
        this.popoverController.dismiss(data);
        break;
      case 'MODAL':
        this.modalController.dismiss(data);
        break;
    }
  }

  onChange() {
    this.onModelChange.emit(this._popoverInfo);
  }

  onClose() {
    if (this.popoverRenderOptionType === 'INLINE') this.popoverController.dismiss();
    else this.modalController.dismiss();
  }

  trackByFn(index: number, item: TMultiSelectFilterGroupInfo['items'][number]): string | number {
    return item.id ?? item.value;
  }
}
